var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28372 9.28372C12.5433 9.28376 15.1908 11.9323 15.1908 15.1918V16.036C15.1904 16.5016 14.8134 16.879 14.3477 16.8791C13.8818 16.8791 13.5039 16.5017 13.5035 16.036V15.1918C13.5035 12.8645 11.6111 10.9721 9.28372 10.972H5.9081C3.58072 10.972 1.68832 12.8644 1.68832 15.1918V16.036C1.68792 16.5017 1.31001 16.8791 0.844158 16.8791C0.378301 16.8791 0.000395818 16.5017 0 16.036V15.1918C0 11.9322 2.64852 9.28372 5.9081 9.28372H9.28372Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59541 0C9.92658 0 11.8151 1.88863 11.8152 4.21978C11.8152 6.55101 9.92663 8.43956 7.59541 8.43956C5.26426 8.43947 3.37562 6.55095 3.37562 4.21978C3.37572 1.88869 5.26431 9.40477e-05 7.59541 0ZM7.59541 1.68832C6.19652 1.68841 5.06403 2.82089 5.06394 4.21978C5.06394 5.61875 6.19646 6.75216 7.59541 6.75225C8.99443 6.75225 10.1279 5.61881 10.1279 4.21978C10.1278 2.82083 8.99438 1.68832 7.59541 1.68832Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/AccountIcon.62c6e8a036a36587f22529f8f924cb3b.svg";
export { ForwardRef as ReactComponent };